// extracted by mini-css-extract-plugin
module.exports = {"tips":"modalSortRates_tips__bzRU0"};